import LinkService from '../../services/LinkService'
import BaseModel from './base'

type LinkDTO = {
  name: string
  fieldKey: string
}
export default class Link extends BaseModel {
  static requestBodyWhiteList = ['name', 'value']

  // Methods
  constructor(data: LinkDTO) {
    super(Link.requestBodyWhiteList, data)
  }

  async save(): Promise<{ [key: string]: any }> {
    return new Promise(async () => {})
  }

  static async list(locationId: string): Promise<LinkDTO[]> {
    const response = await LinkService.list(locationId)
    return response.links.map(link => new Link(link))
  }

  // Getters and Setters
  get name(): string {
    return this.data.name
  }

  set name(value: string) {
    this.data.name = value
    this.updatedData.name = value
  }

  get value(): string {
    return this.data.value
  }

  set value(value: string) {
    this.data.value = value
    this.updatedData.value = value
  }

  get fieldKey(): string {
    return this.data.fieldKey
  }

  get locationId(): string {
    return this.data.locationId
  }
}
